<script>
  export default {
    name: "AppSun",
  }
</script>

<template>
  <div id="sun-ctn">
    <div id="sun"></div>
  </div>
</template>

<style>
  #sun{
    width: 15vh;
    height: 15vh;
    background-color: rgba(241, 254, 127, 0.9);
    border-radius: 50%;
    position: fixed;
    top: 2%;
    right: 8%;
    box-shadow:
        0 0 4vh 1vh rgba(241, 254, 127, 0.6),
        0 0 8vh 2vh rgba(241, 254, 127, 0.4),
        0 0 12vh 3vh rgba(241, 254, 127, 0.2);
    z-index: 0;
  }
</style>